(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6874af42e5be5ff096059223";
              window.beaePageSetting.pageTitle = "awning series"; 
              window.beaePageSetting.pageType = "section";

          let js_22P1IJT0 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-usw2ur5tsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-usw2ur5t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-usw2ur5t');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-usw2ur5t: ', ex)
      };
    

      try {
        let argid = 'beae-nzk8sudnsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nzk8sudn',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nzk8sudn');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nzk8sudn: ', ex)
      };
    

      try {
        let argid = 'beae-a58b37aeblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-a58b37ae',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-a58b37ae');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-a58b37ae: ', ex)
      };
    

      try {
        let argid = 'beae-mu0vts58block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mu0vts58',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mu0vts58');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mu0vts58: ', ex)
      };
    

      try {
        let argid = 'beae-fe48c071section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fe48c071',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fe48c071');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fe48c071: ', ex)
      };
    

      try {
        let argid = 'beae-zj4c4ic7block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zj4c4ic7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zj4c4ic7');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zj4c4ic7: ', ex)
      };
    

      try {
        let argid = 'beae-9ualg4dcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9ualg4dc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9ualg4dc');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9ualg4dc: ', ex)
      };
    

      try {
        let argid = 'beae-3926nan8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3926nan8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3926nan8');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3926nan8: ', ex)
      };
    

      try {
        let argid = 'beae-j5kgxl5hblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-j5kgxl5h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-j5kgxl5h');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-j5kgxl5h: ', ex)
      };
    

      try {
        let argid = 'beae-kmr4wxrtblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kmr4wxrt',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kmr4wxrt');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kmr4wxrt: ', ex)
      };
    

      try {
        let argid = 'beae-ll755lciblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ll755lci',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ll755lci');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ll755lci: ', ex)
      };
    

      try {
        let argid = 'beae-wn7gt7mtbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wn7gt7mt',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wn7gt7mt');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wn7gt7mt: ', ex)
      };
    

      try {
        let argid = 'beae-9skryj0tsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9skryj0t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9skryj0t');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9skryj0t: ', ex)
      };
    

      try {
        let argid = 'beae-mymfml4lblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mymfml4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mymfml4l');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mymfml4l: ', ex)
      };
    

      try {
        let argid = 'beae-oqaltqmublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oqaltqmu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oqaltqmu');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oqaltqmu: ', ex)
      };
    

      try {
        let argid = 'beae-wu8khmv8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wu8khmv8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wu8khmv8');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wu8khmv8: ', ex)
      };
    

      try {
        let argid = 'beae-qvfhwyaublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qvfhwyau',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qvfhwyau');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qvfhwyau: ', ex)
      };
    

      try {
        let argid = 'beae-uavdnqrsblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-uavdnqrs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-uavdnqrs');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-uavdnqrs: ', ex)
      };
    

      try {
        let argid = 'beae-8vsm4dbyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8vsm4dby',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8vsm4dby');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8vsm4dby: ', ex)
      };
    

      try {
        let argid = 'beae-u5ra4qjkbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u5ra4qjk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u5ra4qjk');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u5ra4qjk: ', ex)
      };
    

      try {
        let argid = 'beae-0scf0sfxsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0scf0sfx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0scf0sfx');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0scf0sfx: ', ex)
      };
    

      try {
        let argid = 'beae-9erxa0vbblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9erxa0vb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9erxa0vb');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9erxa0vb: ', ex)
      };
    

      try {
        let argid = 'beae-h50cy731block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h50cy731',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h50cy731');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h50cy731: ', ex)
      };
    

      try {
        let argid = 'beae-j16faid8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-j16faid8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-j16faid8');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-j16faid8: ', ex)
      };
    

      try {
        let argid = 'beae-07xseiszblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-07xseisz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-07xseisz');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-07xseisz: ', ex)
      };
    

      try {
        let argid = 'beae-4vl4seirblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4vl4seir',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4vl4seir');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4vl4seir: ', ex)
      };
    

      try {
        let argid = 'beae-2eankwbsblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2eankwbs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2eankwbs');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2eankwbs: ', ex)
      };
    

      try {
        let argid = 'beae-278c9fnsbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-278c9fns',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-278c9fns');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-278c9fns: ', ex)
      };
    

      try {
        let argid = 'beae-btaaxf28section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-btaaxf28',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-btaaxf28');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-btaaxf28: ', ex)
      };
    

      try {
        let argid = 'beae-nqk2hihhblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nqk2hihh',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nqk2hihh');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nqk2hihh: ', ex)
      };
    

      try {
        let argid = 'beae-xkmk3jc8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xkmk3jc8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xkmk3jc8');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xkmk3jc8: ', ex)
      };
    

      try {
        let argid = 'beae-q84wo1g2block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-q84wo1g2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-q84wo1g2');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-q84wo1g2: ', ex)
      };
    

      try {
        let argid = 'beae-0fw5i04lblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0fw5i04l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0fw5i04l');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0fw5i04l: ', ex)
      };
    

      try {
        let argid = 'beae-o5c4y6mublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-o5c4y6mu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-o5c4y6mu');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-o5c4y6mu: ', ex)
      };
    

      try {
        let argid = 'beae-scr6ynd8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-scr6ynd8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-scr6ynd8');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-scr6ynd8: ', ex)
      };
    

      try {
        let argid = 'beae-u9mc5ryebutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u9mc5rye',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u9mc5rye');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u9mc5rye: ', ex)
      };
    

      try {
        let argid = 'beae-fgwj33z1section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fgwj33z1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fgwj33z1');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fgwj33z1: ', ex)
      };
    

      try {
        let argid = 'beae-6n2p7orrblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6n2p7orr',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6n2p7orr');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6n2p7orr: ', ex)
      };
    

      try {
        let argid = 'beae-nng46oxxsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nng46oxx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nng46oxx');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nng46oxx: ', ex)
      };
    

      try {
        let argid = 'beae-x44tibm4block-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x44tibm4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x44tibm4');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x44tibm4: ', ex)
      };
    

      try {
        let argid = 'beae-n7i4r72bblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n7i4r72b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n7i4r72b');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n7i4r72b: ', ex)
      };
    

      try {
        let argid = 'beae-gq5ef9ewblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gq5ef9ew',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gq5ef9ew');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gq5ef9ew: ', ex)
      };
    

      try {
        let argid = 'beae-6oc8b42pblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oc8b42p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oc8b42p');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oc8b42p: ', ex)
      };
    

      try {
        let argid = 'beae-p4us8i33block-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p4us8i33',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p4us8i33');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p4us8i33: ', ex)
      };
    

      try {
        let argid = 'beae-6oafkt4lblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oafkt4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oafkt4l');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oafkt4l: ', ex)
      };
    

      try {
        let argid = 'beae-x44tibm4block-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x44tibm4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x44tibm4');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x44tibm4: ', ex)
      };
    

      try {
        let argid = 'beae-n7i4r72bblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n7i4r72b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n7i4r72b');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n7i4r72b: ', ex)
      };
    

      try {
        let argid = 'beae-gq5ef9ewblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gq5ef9ew',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gq5ef9ew');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gq5ef9ew: ', ex)
      };
    

      try {
        let argid = 'beae-6oc8b42pblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oc8b42p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oc8b42p');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oc8b42p: ', ex)
      };
    

      try {
        let argid = 'beae-p4us8i33block-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p4us8i33',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p4us8i33');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p4us8i33: ', ex)
      };
    

      try {
        let argid = 'beae-6oafkt4lblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oafkt4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oafkt4l');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oafkt4l: ', ex)
      };
    

      try {
        let argid = 'beae-x44tibm4block-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x44tibm4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x44tibm4');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x44tibm4: ', ex)
      };
    

      try {
        let argid = 'beae-n7i4r72bblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n7i4r72b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n7i4r72b');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n7i4r72b: ', ex)
      };
    

      try {
        let argid = 'beae-gq5ef9ewblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gq5ef9ew',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gq5ef9ew');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gq5ef9ew: ', ex)
      };
    

      try {
        let argid = 'beae-6oc8b42pblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oc8b42p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oc8b42p');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oc8b42p: ', ex)
      };
    

      try {
        let argid = 'beae-p4us8i33block-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p4us8i33',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p4us8i33');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p4us8i33: ', ex)
      };
    

      try {
        let argid = 'beae-6oafkt4lblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oafkt4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oafkt4l');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oafkt4l: ', ex)
      };
    

      try {
        let argid = 'beae-x44tibm4block-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x44tibm4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x44tibm4');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x44tibm4: ', ex)
      };
    

      try {
        let argid = 'beae-n7i4r72bblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n7i4r72b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n7i4r72b');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n7i4r72b: ', ex)
      };
    

      try {
        let argid = 'beae-gq5ef9ewblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gq5ef9ew',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gq5ef9ew');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gq5ef9ew: ', ex)
      };
    

      try {
        let argid = 'beae-6oc8b42pblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oc8b42p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oc8b42p');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oc8b42p: ', ex)
      };
    

      try {
        let argid = 'beae-p4us8i33block-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p4us8i33',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p4us8i33');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p4us8i33: ', ex)
      };
    

      try {
        let argid = 'beae-6oafkt4lblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oafkt4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oafkt4l');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oafkt4l: ', ex)
      };
    

      try {
        let argid = 'beae-x44tibm4block-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x44tibm4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x44tibm4');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x44tibm4: ', ex)
      };
    

      try {
        let argid = 'beae-n7i4r72bblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n7i4r72b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n7i4r72b');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n7i4r72b: ', ex)
      };
    

      try {
        let argid = 'beae-gq5ef9ewblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gq5ef9ew',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gq5ef9ew');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gq5ef9ew: ', ex)
      };
    

      try {
        let argid = 'beae-6oc8b42pblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oc8b42p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oc8b42p');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oc8b42p: ', ex)
      };
    

      try {
        let argid = 'beae-p4us8i33block-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p4us8i33',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p4us8i33');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p4us8i33: ', ex)
      };
    

      try {
        let argid = 'beae-6oafkt4lblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6oafkt4l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6oafkt4l');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6oafkt4l: ', ex)
      };
    

      try {
        let argid = 'beae-4n6irexgblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4n6irexg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4n6irexg');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4n6irexg: ', ex)
      };
    }; if (window.BEAEBASE) {js_22P1IJT0()} else {window.BEAEPAGEJS.push(js_22P1IJT0)} })(); 